import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getPerformanceReportAPI,
  getEarningsReportAPI,
  getClicksReportsAPI,
  allCashbackss,
  getAllmerchantsAPI,
  getAllOffersAPI,

} from "./reportsService";

export interface ReportsState {
  loading: boolean;
  error: any;
  performanceReportData: any;
  earningsReportData: any;
  clicksReportData: any;
  allCashbacksList: any;
  allMerchantsList: any;
  allOffersList: any;


}

const initialState: ReportsState = {
  allCashbacksList: {},
  loading: false,
  error: null,
  performanceReportData: {},
  earningsReportData: {},
  clicksReportData: {}, 
  allMerchantsList: {},
  allOffersList: {},
};

export const reportsSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLoading: (state: ReportsState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    updateErrorMessage: (
      state: ReportsState,
      action: PayloadAction<boolean>
    ) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder: any) => {
    //getAllPricelineSales
    // builder.addCase(getYahooFeeds.pending, (state: any) => {
    //   state.loading = true;
    //   state.error = null;
    // });
    // builder.addCase(
    //   getYahooFeeds.fulfilled,
    //   (state: ReportsState, action: PayloadAction<any>) => {
    //     state.error = null;
    //     state.loading = false;
    //     state.yahooFeeds = action.payload;
    //   }
    // );
    // builder.addCase(
    //   getYahooFeeds.rejected,
    //   (state: ReportsState, action: any) => {
    //     state.loading = false;
    //   }
    // );
    //handleGetAuthTokenAPI
    builder.addCase(getPerformanceReportAPI.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getPerformanceReportAPI.fulfilled,
      (state: ReportsState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.performanceReportData = action.payload;
        localStorage.setItem("extensionUser", JSON.stringify(action.payload));
      }
    );
    builder.addCase(
      getPerformanceReportAPI.rejected,
      (state: ReportsState, action: any) => {
        state.loading = false;
      }
    );
    //getEarningsReportAPI
    builder.addCase(getEarningsReportAPI.pending, (state: any) => {
      state.loading = true;
      state.error = null;
      state.earningsReportData = {};
    });
    builder.addCase(
      getEarningsReportAPI.fulfilled,
      (state: ReportsState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.earningsReportData = action.payload;
      }
    );
    builder.addCase(
      getEarningsReportAPI.rejected,
      (state: ReportsState, action: any) => {
        state.loading = false;
        state.earningsReportData = {};
      }
    );
    //getClicksReportsAPI
    builder.addCase(getClicksReportsAPI.pending, (state: any) => {
      state.loading = true;
      state.error = null;
      state.clicksReportData = {};
    });
    builder.addCase(
      getClicksReportsAPI.fulfilled,
      (state: ReportsState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.clicksReportData = action.payload;
      }
    );
    builder.addCase(
      getClicksReportsAPI.rejected,
      (state: ReportsState, action: any) => {
        state.loading = false;
        state.clicksReportData = {};
      }
    );
    builder.addCase(
      allCashbackss.fulfilled,
      (state: ReportsState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allCashbacksList = action.payload.data;
      }
    );
    builder.addCase(
      getAllmerchantsAPI.fulfilled,
      (state: ReportsState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allMerchantsList = action.payload;
      }
    );
    builder.addCase(
      getAllOffersAPI.fulfilled,
      (state: ReportsState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allOffersList = action.payload;
      }
    );
  },
});

export const { setLoading, updateErrorMessage } = reportsSlice.actions;

export default reportsSlice.reducer;
